import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { LayoutTemplate, ArrowRight } from "lucide-react";
import api from "@/lib/api";
import { CinematicStage, StageHeader, GlassCard, Pill, Spinner, fadeUp, stagger } from "@/components/shared";

export default function Templates() {
  const navigate = useNavigate();
  const [templates, setTemplates] = useState(null);

  useEffect(() => { api.get("/catalogs").then(({ data }) => setTemplates(data.templates)).catch(() => setTemplates([])); }, []);
  if (!templates) return <Spinner label="Loading templates…" />;

  const use = (t) => {
    navigate("/create", { state: { prompt: `${t.name}: ${t.description}`, config: t.preset } });
  };

  return (
    <CinematicStage>
      <StageHeader stage="PRE" room="The Writers' Room · Templates" icon={LayoutTemplate} title="Start from a proven format" subtitle="High-converting content blueprints, pre-tuned with style, pacing and music." />
      <motion.div variants={stagger} initial="hidden" animate="show" className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {templates.map((t) => (
          <motion.div key={t.id} variants={fadeUp}>
            <GlassCard hover className="p-6 h-full flex flex-col" data-testid="template-card">
              <div className="w-11 h-11 rounded-xl bg-[#5B4DFF]/15 grid place-items-center mb-4"><LayoutTemplate className="w-5 h-5 text-[#5B4DFF]" /></div>
              <Pill tone="gold" className="self-start mb-3">{t.category}</Pill>
              <h3 className="font-display text-lg font-semibold">{t.name}</h3>
              <p className="text-sm text-slate-400 mt-1 flex-1">{t.description}</p>
              <div className="flex flex-wrap gap-1.5 my-4">
                {Object.values(t.preset).slice(0, 4).map((v, i) => <span key={`${t.id}-${i}`} className="text-[10px] px-2 py-0.5 rounded-full bg-white/5 border border-white/10 text-slate-400">{v}</span>)}
              </div>
              <button onClick={() => use(t)} data-testid={`template-use-${t.id}`} className="inline-flex items-center justify-center gap-2 px-4 py-2.5 rounded-xl bg-[#5B4DFF]/20 border border-[#5B4DFF]/40 text-white hover:bg-[#5B4DFF]/30 transition text-sm">
                Use Template <ArrowRight className="w-4 h-4" />
              </button>
            </GlassCard>
          </motion.div>
        ))}
      </motion.div>
    </CinematicStage>
  );
}
